import React, { useRef } from "react";
import {
  useLanguage,
  useLanguageUpdate,
  useEnglish,
} from "../context/LanguageContext";
import portugal from "../../assets/portugal.png";
import uk from "../../assets/uk.jpg";

const LanguageSwitch = () => {
  const activeLanguage = useLanguage();
  const toggleLanguage = useLanguageUpdate();
  const isEnglish = useEnglish();
  const animateSwitch = useRef();

  function handleClick() {
    toggleLanguage();
    // setTimeout(() => {
    animateSwitch.current.classList.toggle("language-switch__switcher--right");
    // }, 500);
  }

  return (
    <div className="language-switch">
      <p className="language-switch__title">{activeLanguage.language}</p>
      <div className="language-switch__container" onClick={handleClick}>
        <div className="language-switch__element ">
          <img className="language-switch__flag" src={uk} alt="" />
        </div>
        <div
          className="language-switch__switcher"
          ref={animateSwitch}
          // style={isEnglish ? { left: 0 } : { right: 0 }}
        ></div>
        <div className="language-switch__element">
          <img className="language-switch__flag" src={portugal} alt="" />
        </div>
      </div>
    </div>
  );
};

export default LanguageSwitch;
